import React, { memo } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Box } from '@material-ui/core'
import { ALIGN_REL } from '@v4/constants/quiz'
import EditableHTML from '@v4/components/common/EditableHTML'
import EditableContainer from '@v4/components/common/EditableContainer'
import { EDITOR_VARIANT } from '@v4/hooks/useEditor'
import { useInstructions } from './Instructions.hooks'

const Instructions = props => {
	const [{ className, value, withShadow, align, editable, classes }, { handleChange, handleFocus }] = useInstructions(
		props,
	)

	return (
		<EditableContainer visible={!!value} withoutBanner editable={editable} shadow={withShadow}>
			<Box mb={2} className={className}>
				<EditableHTML
					html={value}
					align={ALIGN_REL[align]}
					className={clsx(classes.text, 'question-instruction-text')}
					variant="body1"
					color="inherit"
					shadow={withShadow}
					editable={editable}
					displayEmpty
					placeholder="Write your instruction here"
					onChange={handleChange}
					editorVariant={EDITOR_VARIANT.SHORT}
					onFocus={handleFocus}
				/>
			</Box>
		</EditableContainer>
	)
}

Instructions.propTypes = {
	value: PropTypes.string,
	className: PropTypes.string,
	align: PropTypes.string,
	backgroundImage: PropTypes.string,
	withShadow: PropTypes.bool,
}

export default memo(Instructions)
